<template>
	<div :class="clsx(className, 'mt-4')">
		<slot />
	</div>
</template>

<script setup lang="ts">
	import {
		clsx,
	} from "clsx"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
	})
</script>